"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Panjangam.js.map